export default "__VITE_ASSET__D$FcQ0r6__"